window.toggleFavoritos = function (articulo_id, obj) {
    let activo = $(obj).hasClass('active');
    $.ajax({
        url:      urlArticulo + '/' + (activo ? 'detach' : 'attach'),
        type:     '' + (activo ? 'POST' : 'POST'),
        data:     {
            id: articulo_id,
        },
        dataType: 'json',
    })
     .done(function (response) {
         $(obj).toggleClass('active')
               .find('i')
               .toggleClass('ri-heart-line ri-heart-fill');
         let span  = $(obj).find('span');
         let total = parseInt($('#totalFavoritos').text());
         if (activo) {
             $(obj).attr('title', transAccionAnadirAFavorito);
             total = total - 1;
             $('#totalFavoritos').text(total);
             $(span).text(transAccionAnadirAFavorito);
         } else {
             $(obj).attr('title', transAccionSepararDeFavorito);
             total = total + 1;
             $('#totalFavoritos').text(total);
             $(span).text(transAccionSepararDeFavorito);
         }
     }).fail(function (jqXHR, status, error) {
        if (jqXHR.status) {
            let errors = '';
            if (jqXHR.status === 422) {
                errors = composeValidationError(jqXHR.responseJSON.errors);
            } else if (jqXHR.responseJSON.message) {
                errors = jqXHR.responseJSON.message;
            }
            pNotifyError(errors);
        }
    });
}

window.toggleMoreActions = function (obj) {
    $(obj).toggleClass('active').find('i').toggleClass('ri-close-fill ri-more-2-fill');
    $(obj).parent().find('.btn-minimal-actions-item').fadeToggle('slow', 'linear');
    $(obj).hasClass('active') ? $(obj).attr('title', transAccionOcultarAcciones) : $(obj).attr('title', transAccionMostrarAcciones);
}




